import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RoomsSearch() {
  return <Navigate to="/rooms" replace />;
}
